import { ApiError } from 'src/api/generated';
import type { CallRecordingAvailability } from '../../types/timeline/call-recording.types';

/** Keeps saved-result actions available during transient playback failures. */
export function hasCallRecording({
  item,
  recording,
  error,
}: CallRecordingAvailability): boolean {
  if (error instanceof ApiError && error.status === 404) return false;
  return (
    Boolean(recording) ||
    Boolean(item.recordingUrl) ||
    Boolean(item.transcription) ||
    Boolean(item.analysis)
  );
}
